var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "div",
        { staticClass: "shopSearchResult" },
        [
          _c("div", {
            staticClass: "ui vertical loader",
            class: { active: _vm.waiting && _vm.shops.length === 0 },
          }),
          _vm._v(" "),
          _vm._t("banner"),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.waiting,
                  expression: "!waiting",
                },
              ],
              staticClass: "shopSearchResult__resultNumberContainer",
            },
            [
              _vm._v("\n      宴会・パーティー会場検索結果"),
              _c("span", { staticClass: "shopSearchResult__resultNumber" }, [
                _vm._v(_vm._s(_vm.pager.total)),
              ]),
              _vm._v("件\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.waiting,
                  expression: "!waiting",
                },
              ],
              staticClass: "shopSearchResult__selectionListContainer",
            },
            [
              _c(
                "div",
                { staticClass: "shopSearchResult__selectionListTitle" },
                [
                  _vm._v("\n        まとめて問い合わせリスト "),
                  _c("span", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.$root.selectedShopCount)),
                  ]),
                  _vm._v(" 件\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "shopSearchResult__selectionListHint" },
                [_vm._v("（最大10件選択可能です）")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "shopSearchResult__shopList" },
            [
              _c("search-result-shop", {
                attrs: { shops: _vm.pr_shops, "is-promotion": true },
              }),
              _vm._v(" "),
              _c("search-result-shop", { attrs: { shops: _vm.filteredShops } }),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("front-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.waiting,
            expression: "!waiting",
          },
        ],
        attrs: { pager: _vm.pager, form: _vm.form },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }